import { render, staticRenderFns } from "./WeekTemplateActions.vue?vue&type=template&id=0ef5ebd8&scoped=true&"
import script from "./WeekTemplateActions.vue?vue&type=script&lang=js&"
export * from "./WeekTemplateActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef5ebd8",
  null
  
)

export default component.exports